/* EcoSparkle Home — Subscription Landing Page JS */

/* ── Add to cart with source tracking ── */
async function addSubscriptionToCart() {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: STARTER_VARIANT_ID,
          quantity: 1,
          properties: { '_source': 'subscribe-landing', '_intent': 'subscription-20-off' }
        }]
      })
    });
    if (res.ok) {
      if (window.gtag) gtag('event', 'add_to_cart', { value: 300, currency: 'ILS', source: 'subscribe' });
      if (window.fbq)  fbq('track', 'AddToCart', { value: 300, currency: 'ILS' });
      window.location.href = '/checkout';
    } else {
      const err = await res.json();
      alert(err.description || 'משהו השתבש. נסו שוב.');
    }
  } catch (e) {
    alert('שגיאת רשת. בדקו חיבור לאינטרנט ונסו שוב.');
  }
}

/* ── Sticky CTA ── */
(function initStickyCta() {
  const el = document.getElementById('stickyCta');
  if (!el) return;
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        const show = window.scrollY > 800;
        el.classList.toggle('visible', show);
        el.setAttribute('aria-hidden', String(!show));
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

/* ── FAQ accordion ── */
(function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-q[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.hidden = true;
        }
      });
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.nextElementSibling.hidden = expanded;
    });
  });
})();

/* ── Intersection observer fade-in ── */
(function initFadeIn() {
  const sections = document.querySelectorAll('.fade-in-section');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('visible'); });
    return;
  }
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  sections.forEach(function (s) { obs.observe(s); });
})();

/* ── Smooth scroll anchors ── */
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});
